import {
  Component,
  ElementRef,
  EventEmitter,
  Input,
  OnInit,
  Output,
  ViewChild,
  ViewEncapsulation,
} from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { CreatePlaceCommand } from '../../../../../server/src/commands/hub/create.place.command';
import { config } from '../../../../config/config';
import { CreateTourCommand } from '../../../commands/hub/create.tour.command';
import { CreateEventCommand } from '../../../commands/hub/event/create.event.command';
import { ImageService } from '../../../services/image.service';
import { BaseComponent } from '../base.component';
import { SuccessWrapComponent } from '../success.wrap/success.wrap.component';

@Component({
  selector: 'ig-image-selector',
  templateUrl: './image.selector.component.html',
  styleUrls: ['./image.selector.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ImageSelectorComponent extends BaseComponent implements OnInit {
  @Input() public sizeLimit = config.eventImageSizeLimit;
  @Input() public command: CreateEventCommand | CreateTourCommand | CreatePlaceCommand | ImageSelectorCommand;
  @Input() public selectedImageData: any;
  @Input() public isSmallIcon: boolean;
  @Input() public disabled: boolean;
  @Input() public isSimple = false;
  @Input() public isShowUploadIcon = true;
  @Input() public label = 'SELECT YOUR IMAGE (PNG/JPG/GIF)';
  @Input() public label2 = '';
  @Input() public updateLabel = 'UPDATE YOUR IMAGE';
  @ViewChild('imageSelector') public imageSelector: ElementRef;
  @Output() public onUpload = new EventEmitter<any>();
  @Output() public onImageChanged = new EventEmitter<any>();
  @ViewChild('upload') public uploadImageSuccess: SuccessWrapComponent;
  public isShowUploadingSpinner = false;

  constructor(private imageService: ImageService) {
    super();
  }

  public ngOnInit() {}

  public onImageChange($event) {
    this.command.image = $event.srcElement.files[0];
    if (!!this.command.image) {
      //if (this.command.image.size <= this.sizeLimit) {
      let reader = new FileReader();

      reader.onload = async (e) => {
        this.selectedImageData = e.target['result'];

        const imageFile = await this.imageService.compressImageFile(this.command.image);
        this.onImageChanged.emit(imageFile);
      };

      reader.readAsDataURL(this.command.image);
      // } else {
      //     window.alert('This image is too large!');
      //     this.imageSelector.nativeElement.value = '';
      // }
    }
  }

  public clearImage() {
    this.command.image = null;
    this.selectedImageData = null;
    this.imageSelector.nativeElement.value = '';
    this.onImageChanged.emit(null);
  }

  public updateImage() {
    this.onUpload.emit(this.command.image);
  }

  public safeImage(): SafeUrl {
    return this.imageService.safeImage(this.imageService.imageSourceUrl(this.selectedImageData));
  }

  public showSpinner() {
    this.isShowUploadingSpinner = true;
  }

  public hideSpinner() {
    this.isShowUploadingSpinner = false;
  }
}

export class ImageSelectorCommand {
  public image: File;
}



// WEBPACK FOOTER //
// D:/Work/Development/vsts_build/_work/2/s/web/src/common/components/image.selector/image.selector.component.ts